module.exports = __webpack_public_path__ + "img/reference-breddys-crossoverpants.7a764a2d.jpg";